import { Helmet } from "react-helmet-async";

const SEO = ({ 
  title = "Shylov Cleaning - Yacht Cleaning, Car Detailing & Marble Care",
  description = "Yacht and boat cleaning, car detailing, marble polishing and restoration, residential and construction cleaning on the French Riviera.",
  keywords = "yacht cleaning, bow cleaning, bottom cleaning, car detailing, marble polishing, marble restoration, residential cleaning, construction cleaning, French Riviera, Nice, Cannes, Monaco",
  image = "/images/services/yacht-hero.webp",
  url = "",
  type = "website",
  locale = "en_US"
}) => {
  const siteUrl = process.env.REACT_APP_BACKEND_URL.replace(/\/$/, "");
  const fullUrl = url ? `${siteUrl}${url}` : siteUrl;
  const fullImage = image.startsWith("http") ? image : `${siteUrl}${image}`;

  // Structured Data for Local Business
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Shylov Cleaning",
    "description": description,
    "image": fullImage,
    "url": siteUrl,
    "telephone": "+33756888821",
    "email": "shylov.cleaning@gmail.com",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Nice",
      "addressRegion": "Provence-Alpes-Côte d'Azur",
      "addressCountry": "FR"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 43.7102,
      "longitude": 7.2620
    },
    "areaServed": [
      { "@type": "City", "name": "Nice" },
      { "@type": "City", "name": "Cannes" },
      { "@type": "City", "name": "Monaco" },
      { "@type": "City", "name": "Cagnes-sur-Mer" },
      { "@type": "City", "name": "Antibes" }
    ],
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
      "opens": "00:00",
      "closes": "23:59"
    },
    "priceRange": "€€€",
    "sameAs": [
      "https://wa.me/33756888821",
      "https://www.instagram.com/shylov_cleaning/"
    ],
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Cleaning Services",
      "itemListElement": [
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Mobile Car Detailing", "description": "Our team travels to the customer for on-site exterior washing, interior cleaning and paintwork polishing. No vehicle drop-off required." } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Bow and Bottom Cleaning", "description": "Cleaning of yacht and boat bows and bottoms, with scope and access agreed after inspection" } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Marble Polishing and Restoration", "description": "Care and restoration of marble floors, countertops and yacht interiors" } },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Yacht Cleaning",
            "description": "Professional exterior and interior yacht cleaning services"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Residential Cleaning",
            "description": "Villa, apartment, and house cleaning services"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Construction Cleaning",
            "description": "Post-construction and renovation cleanup"
          }
        }
      ]
    }
  };

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={fullUrl} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:locale" content={locale} />
      <meta property="og:site_name" content="Shylov Cleaning" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImage} />
      
      {/* Additional SEO */}
      <meta name="robots" content="index, follow" />
      <meta name="author" content="Shylov Cleaning" />
      <meta name="geo.region" content="FR-06" />
      <meta name="geo.placename" content="Nice, France" />
      
      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};

export default SEO;
